(function() {
  const currentUrl = window.location.href;
  const filterEl = document.getElementById('FacetSortForm');

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, options = {}) {
    options = {
      path: '/',
      ...options
    };
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
  
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
  
    document.cookie = updatedCookie;
  }

  function deleteCookie(name) {
    setCookie(name, "", {
      'max-age': -1
    })
  }

  if (currentUrl.includes('collections')) {
    const collectionName = currentUrl.split('collections/').pop().split('?').shift();
    const pageNumber = new URLSearchParams(document.location.search).get('page');

    if (filterEl && getCookie('collection-name') === collectionName && pageNumber < 2) {
      window.addEventListener('load', () => {
        const y = filterEl.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({top: y, behavior: 'smooth'});
      });
    }

    setCookie('collection-name', collectionName);
  } else {
    deleteCookie('collection-name');
  }
})();
